import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Grid from 'UIKit/Box/Grid'
import { useRequest } from 'hooks/useRequest'
import Column from 'layout/Components/Column'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import SurveyService from 'services/SurveyService'
import { SurveyTypeEnum } from 'services/types'
import { ModalColorTheme } from 'theme/modal/colors'
import { HunnyToast } from 'utils/toastify'
import { AnswerOption, QuestionDescription, QuestionTitle, WrapperQuestion } from './styled'

const questions = [
  {
    title: 'How do you feel about the bonus being canceled?',
    key: 'cancelbonus',
    description: 'This helps us send you the most suitable bonuses.',
    answers: [
      {
        answer: 'I have a better bonus',
        logo: '/images/survey/emoji-like.png',
        key: 1,
      },
      {
        answer: 'Not interested in this bonus',
        logo: '/images/survey/emoji-consider.png',
        key: 2,
      },
      {
        answer: 'This bonus is challenging',
        logo: '/images/survey/emoji-sad.png',
        key: 3,
      },
    ],
  },
] as const

const CancelBonusSurveyModal: React.FC<ModalProps<{ bonusId: string }>> = ({ onDismiss, data: { bonusId } }) => {
  const [answers, setAnswers] = useState<{ [key: string]: number }>({})
  const [activeAt, setActiveAt] = useState<string>(questions[0].key)
  const { execute } = useRequest()
  const { t } = useTranslation()

  const handleSelectAnswer = async (indexQuestion: number, idx: number) => {
    const question = questions[indexQuestion]
    const _answers = { ...answers }

    _answers[question.key] = question.answers[idx].key
    setAnswers(_answers)

    const nextQuestion = questions[indexQuestion + 1]
    if (nextQuestion) {
      setActiveAt(nextQuestion.key)
    } else {
      const data = await execute(
        SurveyService.userSurvey({
          answer: _answers,
          targetId: bonusId,
          surveyCode: SurveyTypeEnum.CancelBonus,
        }),
      )

      if (data.code === 'success') {
        HunnyToast.success(t('Survey'), t('Your answer has been recorded'))
      }

      onDismiss()
    }
  }

  return (
    <AlchemyModal
      onDismiss={onDismiss}
      minWidth={['100% !important', '', '', '675px !important']}
      maxWidth={675}
      colorTheme={ModalColorTheme.Darkblue}
    >
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} />
      <ModalBody>
        <Column>
          {questions.map(
            (question, indexQuestion) =>
              activeAt === question.key && (
                <WrapperQuestion my={['12px', '', '24px']}>
                  <Column mb="24px">
                    <QuestionTitle mb="4px">
                      <Trans>{question.title}</Trans>
                    </QuestionTitle>
                    <QuestionDescription>
                      <Trans>{question.description}</Trans>
                    </QuestionDescription>
                  </Column>
                  <Grid gridTemplateColumns={['1fr', '', '1fr 1fr 1fr']} gridGap={['0', '', '20px']}>
                    {question.answers.map((answer, idx) => (
                      <AnswerOption
                        index={idx}
                        minHeight={64}
                        onClick={() => handleSelectAnswer(indexQuestion, idx)}
                        mb={idx < question.answers.length - 1 ? '12px' : '0'}
                        logo={answer.logo}
                        text={answer.answer}
                      />
                    ))}
                  </Grid>
                </WrapperQuestion>
              ),
          )}
        </Column>
      </ModalBody>
    </AlchemyModal>
  )
}

export default CancelBonusSurveyModal
